import { useDailyCalendar } from '@/v2/hooks/calendar/useCalendar'

const useNextAppointments = ({ date }) => {
  const { data, isLoading: loading, isError: error } = useDailyCalendar(date)
  const [dailyData] = data || []
  const appointments = dailyData?.appointments || null

  return { appointments, loading, error }
}

export default useNextAppointments
